import { Box, Button, IconButton, Section } from "@origin-digital/ods-core";
import { IconChevronLeftSmall, IconClose } from "@origin-digital/ods-icons";
import React from "react";
import { ActionBarProps } from "./ActionBar";
import { NavTitle } from "./NavTitle";

export interface ActionBarMobileProps extends ActionBarProps {
  title?: string;
  isDesktop?: boolean;
}

export function getMobileNavButton(
  mobileNavButton: ActionBarProps["mobileNavButton"],
  onClickMobileNavButton: ActionBarProps["onClickMobileNavButton"],
  isDesktop: boolean = false,
  desktopVariant?: ActionBarProps["desktopVariant"],
  showPropertySelector?: boolean
) {
  if (!mobileNavButton || mobileNavButton === "none") {
    // Don't show placeholder when PropertySelector is displayed
    if (showPropertySelector) {
      return null;
    }
    // placeholder to help keep the title centered
    return (
      <Box
        display="flex"
        style={{ height: "44px", width: isDesktop ? "auto" : "44px" }}
        justifyContent="flex-end"
      />
    );
  }

  const isCloseButton = mobileNavButton === "close";
  const label = isCloseButton ? "Close" : "Back";
  const ariaLabel = isCloseButton ? "Close Flow" : label;
  const icon = isCloseButton ? (
    <IconClose color="neutralDark" size="xxsmall" variant="solid" />
  ) : (
    <IconChevronLeftSmall color="neutralDark" variant="solid" size="xxsmall" />
  );
  const dataId = `button-${mobileNavButton}${isDesktop ? "-desktop" : ""}`;

  if (isDesktop && desktopVariant === "slim") {
    return (
      <Button
        aria-label={ariaLabel}
        color="secondaryB"
        data-id={dataId}
        icon={icon}
        onClick={onClickMobileNavButton}
        size="small"
        variant="text"
      >
        {label}
      </Button>
    );
  }

  return (
    <IconButton
      aria-label={ariaLabel}
      color="secondaryB"
      data-id={dataId}
      onClick={onClickMobileNavButton}
    >
      {icon}
    </IconButton>
  );
}

export const ActionBarMobile = ({
  mobileNavButton,
  headingComponent,
  onClickMobileNavButton,
  title,
  showPropertySelector,
  propertySelector,
  onClickChatButton,
  showChatButton,
}: ActionBarMobileProps) => {
  return (
    <Section
      paddingY="none"
      data-id="mobile-container"
      backgroundColor="transparent"
      hideGutter={true}
    >
      <Box display="flex" justifyContent="space-between">
        <NavTitle
          mobileNavButton={mobileNavButton}
          headingComponent={headingComponent}
          onClickMobileNavButton={onClickMobileNavButton}
          title={title}
          showPropertySelector={showPropertySelector}
          propertySelector={propertySelector}
          onClickChatButton={onClickChatButton}
          showChatButton={showChatButton}
        />
      </Box>
    </Section>
  );
};
